import { LUDUM_USER_STATUSES } from '@/constants';
const { APPROVED, INVITED, ONBOARDING, PENDING } = LUDUM_USER_STATUSES;

export const clubMembers = {
    namespaced: true,

    state: {
        bulkActionMembers: [],
        filter: {
            squads: [],
            statuses: [APPROVED, INVITED, ONBOARDING, PENDING],
            roles: [],
            query: ''
        }
    },

    mutations: {
        setFilter(state, data) {
            state.filter = data;
        },

        emptyBulkMembers(state) {
            state.bulkActionMembers = [];
        },

        manageBulkActionMember(state, data) {
            const { event, member } = data;
            const index = state.bulkActionMembers.findIndex(({ userId }) => userId === member.userId);

            if (index === -1 && event) {
                state.bulkActionMembers.push(member);
            } else if (index !== -1 && !event) {
                state.bulkActionMembers.splice(index, 1);
            }
        },

        setRoles(state, payload) {
            state.filter.roles = payload;
        },

        setStatus(state, payload) {
            state.filter.statuses = payload;
        },

        setSquads(state, payload) {
            state.filter.squads = payload;
        }
    },

    getters: {
        getClubMembersFilter(state) {
            return state.filter;
        },

        bulkActionMembers(state) {
            return state.bulkActionMembers;
        }
    },

    actions: {
        userChangeStatus(context, payload) {
            return context.dispatch(
                'post',
                {
                    url: api + 'user-change-status/' + payload.id,
                    data: payload
                },
                { root: true }
            );
        },

        getUserStatuses(context) {
            return context.dispatch(
                'get',
                {
                    url: api + 'club-statuses'
                },
                { root: true }
            );
        }
    }
};

export default clubMembers;
